export default __webpack_public_path__ + "54fb7f2cff032944483dd2c969b3abb0.jpg";